import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

// @mui/icon components
import InfoIcon from '@mui/icons-material/InfoOutlined';

import CrmRadio from './CrmRadio';

const localStyles = (theme) => ({
  root: {
    padding: '4px 10px 0 10px',
    border: '1px solid #aaaaaa',
    borderRadius: '3px',
  },
  '@keyframes blinker': {
    from: { opacity: 0.5 },
    to: { opacity: 1 },
  },
  commandDiv: {
    fontSize: '115%',
    fontWeight: 'bold',
    animationName: '$blinker',
    animationDuration: '4s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationDirection: 'alternate-reverse',
  },
  invisibleCommandDiv: {
    display: 'none',
  },
  radioButton: {
    padding: '8px 3px 12px 12px',
    color: theme.palette.primary.main,
    '&>span>div>svg': {
      fontSize: '22px',
    },
  },
  radioButtonSpan: {
    cursor: 'pointer',
  },
  infoIcon: {
    color: '#77aaff',
    transform: 'translate(-2px, 6px) scale(0.8)',
  },
});

class NewOrgArityChoicePanel extends React.Component {
  multipleInfo = 'Register a Referral Contact who is a member of a Company that might have other Contacts, too.';
  singleInfo = 'Register a Referral Contact who works as an individual';

  handleArityChange(newArity) {
    this.props.ownerModal.setArity(newArity);
  }

  showInfoForSingle() {
    this.props.ownerModal.setState({ shouldShowAlertModal: true, alertModalText: this.singleInfo });
  }

  showInfoForMultiple() {
    this.props.ownerModal.setState({ shouldShowAlertModal: true, alertModalText: this.multipleInfo });
  }

  render() {
    const { classes } = this.props;
    const arity = this.props.ownerModal.state.arity;
    const commandDivStyle = arity ? classes.invisibleCommandDiv : classes.commandDiv;

    return (
      <div className={classes.root}>
        <div className={commandDivStyle}>Please choose one:</div>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <CrmRadio
              className={classes.radioButton}
              checked={arity === 'Multiple'}
              onChange={() => this.handleArityChange('Multiple')}
              value="single"
              name="radio-group-arity"
            />
            <span className={classes.radioButtonSpan} onClick={() => this.handleArityChange('Multiple')}>
              Consultancy Group
            </span>
            <InfoIcon className={classes.infoIcon} onClick={() => this.showInfoForMultiple()} />
          </Grid>
          <Grid item xs={6}>
            <CrmRadio
              className={classes.radioButton}
              checked={arity === 'Single'}
              onChange={() => this.handleArityChange('Single')}
              value="multiple"
              name="radio-group-arity"
            />
            <span className={classes.radioButtonSpan} onClick={() => this.handleArityChange('Single')}>
              Individual Consultant
            </span>
            <InfoIcon className={classes.infoIcon} onClick={() => this.showInfoForSingle()} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(localStyles)(NewOrgArityChoicePanel);
